import { render, staticRenderFns } from "./ZaloChatHistory.vue?vue&type=template&id=4e26587e&scoped=true"
import script from "./ZaloChatHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ZaloChatHistory.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ZaloChatHistory.vue?vue&type=style&index=0&id=4e26587e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e26587e",
  null
  
)

export default component.exports